import { boot } from 'quasar/wrappers'

import { System } from 'src/store/System'

export default boot (({ store }) => {
  // console.log('registrationForm', process.env.registrationForm)
  System.directCommit_setRecaptchaKey(process.env.GOOGLE_RECAPTCHA_SITE_KEY!)
})
